<template>
  <b-row>
    <b-col cols="12">
      <update-profile-request-edit-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import UpdateProfileRequestEditForm from './UpdateProfileRequestEditForm.vue'

export default {
  components: {
    BRow,
    BCol,
    UpdateProfileRequestEditForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
